<div id="content">
  <div class="page-title d-flex align-items-center justify-content-between flex-wrap mb-3">
    <h1 class="mb-0">{{ page_title }}</h1>
    <div class="page-title-actions d-flex flex-wrap gap-2">
      <a mat-stroked-button routerLink="/employees/rrhh/exam-templates">
        <mat-icon>description</mat-icon>
        Plantillas
      </a>
      <a mat-stroked-button routerLink="/employees/rrhh/skill-questions">
        <mat-icon>quiz</mat-icon>
        Banco de preguntas
      </a>
      <button mat-flat-button color="accent" type="button" (click)="openCreateDialog()">
        <mat-icon>add</mat-icon>
        Nuevo examen
      </button>
    </div>
  </div>

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
        style="margin-right: auto"
      ></mat-paginator>

      <mat-form-field>
        <input matInput type="text" formControlName="search" placeholder="Buscar..." />
        <button matSuffix mat-icon-button aria-label="Buscar" type="button">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </form>

    <div class="bisual-table-container">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="template">
          <th mat-header-cell *matHeaderCellDef>Plantilla</th>
          <td mat-cell *matCellDef="let element">{{ element.template_name_label }}</td>
        </ng-container>

        <ng-container matColumnDef="questions_count">
          <th mat-header-cell *matHeaderCellDef>Preguntas</th>
          <td mat-cell *matCellDef="let element">{{ element.questions_count_label }}</td>
        </ng-container>

        <ng-container matColumnDef="total_minutes">
          <th mat-header-cell *matHeaderCellDef>Tiempo</th>
          <td mat-cell *matCellDef="let element">{{ element.total_minutes_label }}</td>
        </ng-container>

        <ng-container matColumnDef="evaluations_last_12_months">
          <th mat-header-cell *matHeaderCellDef>Eval. 12 meses</th>
          <td mat-cell *matCellDef="let element">{{ element.evaluations_last_12_months_label }}</td>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef>Creado</th>
          <td mat-cell *matCellDef="let element">{{ element.created_at | date: 'dd/MM/yyyy' }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="actions-cell">
            <div class="table-actions">
              <a mat-icon-button [routerLink]="['/employees', 'rrhh', 'exam-instances', element.id]" matTooltip="Ver detalle">
                <mat-icon>visibility</mat-icon>
              </a>
              <button
                mat-icon-button
                type="button"
                [matTooltip]="element.delete_disabled_tooltip"
                [disabled]="!element.can_delete"
                (click)="deleteExamInstance(element)"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
